import { useSetAtom } from 'jotai';
import React__default, { useState, useRef, useCallback, useEffect } from 'react';
import '../../rev/layouts/Alignment/alignment.scss';
import '../../rev/layouts/Box.js';
import '../../rev/layouts/Group.js';
import '../../rev/layouts/Section.js';
import '../../rev/layouts/Spacing/spacing.scss';
import { Stack } from '../../rev/layouts/Stack.js';
import '../../rev/atoms/Badge.scss';
import 'react-aria-components';
import '../../rev/atoms/Breadcrumbs.scss';
import { Button } from '../../rev/atoms/Button.js';
import { Callout } from '../../rev/atoms/Callout.js';
import '../../rev/atoms/Card.scss';
import '../../rev/atoms/Checkbox.js';
import 'lodash';
import '../../rev/atoms/CheckboxGroup.scss';
import '../../rev/atoms/Tag.scss';
import '../../rev/atoms/Chip.scss';
import '../../rev/atoms/DateInput.js';
import '../../rev/atoms/Text.js';
import '../../rev/atoms/Divider.scss';
import '../../rev/atoms/Spinner.scss';
import '../../rev/atoms/Dropzone.scss';
import '../../rev/atoms/Empty.scss';
import 'motion/react';
import '../../rev/molecules/RichDescription.js';
import '../../rev/molecules/TitleGroup.scss';
import '../../rev/atoms/EmptySearchResults.scss';
import 'classnames';
import '../../rev/atoms/Image.scss';
import '@mui/icons-material/EmailOutlined';
import '@mui/icons-material/PhoneOutlined';
import '@mui/icons-material/PlaceOutlined';
import '@mui/icons-material/ScheduleOutlined';
import '../../rev/atoms/LabelledList.scss';
import '../../rev/atoms/LabelPrice.scss';
import '../../rev/atoms/Link.scss';
import '../../rev/atoms/ListViewGroup.scss';
import '../../rev/atoms/ListViewRow.scss';
import '../../rev/atoms/Note.scss';
import '../../rev/atoms/OldTextInput.js';
import '../../rev/atoms/RadioGroup.scss';
import 'framer-motion';
import '../../rev/atoms/SegmentedControl.scss';
import '../../rev/atoms/Skeleton.scss';
import '@mui/icons-material/InfoOutline';
import '../../rev/molecules/Tooltip/Tooltip.js';
import '../../rev/atoms/Slider.scss';
import '../../rev/atoms/SteppedProgressBar.scss';
import '../../rev/atoms/Switch.js';
import '../../rev/atoms/Tabs.scss';
import '../../rev/atoms/TextArea.js';
import '../../rev/atoms/TextInput.js';
import '../../rev/atoms/TimeInput.js';
import '../../rev/atoms/ToggleButton.js';
import '../../rev/atoms/ToggleGroup.js';
import 'react-dom';
import '../../rev/molecules/EmbeddedVideoPlayer/EmbeddedVideoPlayer.scss';
import '../../rev/molecules/Accordion.scss';
import '../../rev/molecules/ActionMenu.scss';
import '../../rev/molecules/BankInfo/BankInfo.scss';
import '../../rev/molecules/Carousel.scss';
import '../../rev/molecules/ContentSlider.js';
import '../../rev/molecules/Drawer.js';
import '../../rev/molecules/Dropdown.scss';
import '../../rev/molecules/Form/index.js';
import '@dnd-kit/core';
import '../../rev/molecules/Kanban/KanbanBoard.scss';
import '../../rev/molecules/Lightbox.scss';
import '../../components/loadingAtoms.js';
import '../../rev/molecules/LoadingPage.scss';
import '../../rev/molecules/NavigationMenu.scss';
import '@mui/icons-material/Search';
import 'react-aria';
import 'react-stately';
import 'smartystreets-javascript-sdk';
import 'smartystreets-javascript-sdk-utils';
import '../../utils/addressCache.js';
import '../../rev/molecules/OldAddressInput.scss';
import '../../rev/atoms/Button.scss';
import '../../rev/molecules/OrderFooter.scss';
import '../../rev/molecules/Pagination.scss';
import '../../rev/molecules/Popover.js';
import '../../rev/molecules/Popup.scss';
import '../../rev/molecules/SearchInput.scss';
import '../../rev/molecules/Sheet.js';
import '../../rev/molecules/Table/Table.scss';
import '../../rev/molecules/Toast.js';
import '../../rev/molecules/ToggleCard/ToggleCard.scss';
import '../../rev/molecules/ToggleCard/ToggleCardDescriptionBlock.scss';
import '../../rev/molecules/ToggleCard/ToggleCardGroup.scss';
import '../../rev/molecules/ToggleCard/ToggleCardHeader.scss';
import '../../rev/molecules/ToggleCard/ToggleCardRadioContent.scss';
import '@react-aria/utils';
import '../../rev/molecules/TopBar.scss';
import '@mui/icons-material/Check';
import '../../rev/organisms/ach/ConnectBankAccount.scss';
import '../../rev/organisms/ach/ConnectedBankInfo.scss';
import '../../rev/organisms/AddressInput.js';
import '../../rev/sections/CalculatePaymentModal.scss';
import '../../rev/sections/ConfirmAddressModal.scss';
import '../../rev/sections/CoverageMenuSection/CoverageItemAssurance.scss';
import '../../rev/sections/CoverageMenuSection/CoverageItemProductSummary.js';
import '../../rev/sections/CoverageMenuSection/CoverageMenuSection.scss';
import '../../rev/sections/CoverageMenuSection/fixtures/coverageMenuFixtureData.js';
import 'react-hook-form';
import '../../rev/sections/FormModal/schemas.js';
import '@hookform/resolvers/zod';
import '@internationalized/date';
import '../../constants.js';
import '../../rev/sections/FormModal/FormModal.scss';
import '../../rev/sections/FormModal/types.js';
import 'moment';
import '../../types/leads/Lead.js';
import '../../rev/sections/LeadsSection/LeadCard.scss';
import { userAtom, accessTokenAtom, isAuthenticatedAtom } from '../atoms/authAtoms.js';
import { mfaChallengeBaseAtom, clearMfaChallengeAtom } from '../atoms/mfaChallengeAtoms.js';
import { useAuth } from '../hooks/useAuth.js';
import { useCooldown } from '../hooks/useCooldown.js';
import { useAuthContext } from '../providers/AuthContext.js';
import { getMfaErrorMessage } from '../utils/authErrorMessages.js';
import { isCypressEnvironment, createTestVerifierIfCypress } from '../utils/testRecaptchaVerifier.js';
import { PinInput } from './common/PinInput.js';
import './MfaChallengeForm.scss';

// Cooldown duration in seconds for resend button
const RESEND_COOLDOWN_SECONDS = 30;
/**
 * Formats a masked phone number from Firebase into a user-friendly display format.
 * Firebase returns formats like "+*******9422" - we convert to "••• ••• 9422"
 */
function formatMaskedPhone(phoneNumber) {
    if (!phoneNumber)
        return '••• ••• ••••';
    // Remove the leading '+' if present
    const cleaned = phoneNumber.replace(/^\+/, '');
    // Extract the visible digits (last 4 typically)
    const visibleDigits = cleaned.replace(/\*/g, '');
    // Return a nicely formatted masked number
    return `••• ••• ${visibleDigits || '••••'}`;
}
/**
 * MfaChallengeForm component
 *
 * Handles the SMS verification flow for MFA challenge:
 * 1. User clicks "Send code" to trigger SMS (required for reCAPTCHA)
 * 2. User enters the received 6-digit code
 * 3. Verifies and completes sign-in
 * 4. Calls onSuccess callback on success
 *
 * Note: Invisible reCAPTCHA requires user interaction (button click) to work properly.
 * Auto-sending on mount causes "NO_RECAPTCHA" errors.
 */
function MfaChallengeForm({ onSuccess, onCancel, isProcessing = false, }) {
    const { authService, apiClient, mfaSmsService } = useAuthContext();
    const { mfaPending, mfaResolver, mfaPhoneVerificationId, mfaEnrolledFactors, clearMfaChallenge, } = useAuth();
    // Form state
    const [verificationCode, setVerificationCode] = useState('');
    const [error, setError] = useState(null);
    const [isSendingCode, setIsSendingCode] = useState(false);
    const [isVerifying, setIsVerifying] = useState(false);
    const [codeSent, setCodeSent] = useState(false);
    // Resend cooldown
    const { cooldownSeconds, startCooldown } = useCooldown(RESEND_COOLDOWN_SECONDS);
    // Atom actions
    const setMfaChallenge = useSetAtom(mfaChallengeBaseAtom);
    const clearMfaState = useSetAtom(clearMfaChallengeAtom);
    // Auth state setters (for updating state after MFA success)
    const setUser = useSetAtom(userAtom);
    const setAccessToken = useSetAtom(accessTokenAtom);
    const setIsAuthenticated = useSetAtom(isAuthenticatedAtom);
    // Verifier state - can be either real RecaptchaVerifier or test mock
    // In E2E mode, we use a mock verifier that bypasses reCAPTCHA UI
    const verifierRef = useRef(null);
    const [verifierReady, setVerifierReady] = useState(false);
    const verifierInitAttempted = useRef(false);
    // Check if we're in E2E/test environment (computed once)
    const isCypress = useRef(isCypressEnvironment());
    // Use a stable container ID - Firebase will look up by ID, avoiding stale ref issues
    const RECAPTCHA_CONTAINER_ID = 'mfa-recaptcha-container';
    /**
     * Initialize the verifier appropriate for the current environment.
     *
     * In Cypress: Uses a mock verifier that bypasses reCAPTCHA UI
     * Otherwise: Uses real RecaptchaVerifier with invisible reCAPTCHA
     */
    const initializeVerifier = useCallback(() => {
        // CYPRESS: Use mock verifier (no reCAPTCHA UI)
        if (isCypress.current) {
            const testVerifier = createTestVerifierIfCypress();
            if (testVerifier) {
                verifierRef.current = testVerifier;
                setVerifierReady(true);
                return;
            }
        }
        // Clear existing verifier if any
        if (verifierRef.current && 'clear' in verifierRef.current) {
            try {
                verifierRef.current.clear();
            }
            catch {
                // Ignore cleanup errors
            }
            verifierRef.current = null;
        }
        setVerifierReady(false);
        // Wait for the container to be in the DOM
        let container = document.getElementById(RECAPTCHA_CONTAINER_ID);
        if (!container) {
            return;
        }
        // reCAPTCHA v2 tracks which DOM elements have been used for rendering.
        // Simply clearing innerHTML doesn't work - we must completely remove and
        // recreate the DOM element to get a fresh reCAPTCHA instance for resend.
        const parent = container.parentElement;
        if (parent) {
            container.remove();
            const newContainer = document.createElement('div');
            newContainer.id = RECAPTCHA_CONTAINER_ID;
            parent.prepend(newContainer);
            container = newContainer;
        }
        const verifier = mfaSmsService.createRecaptchaVerifier(RECAPTCHA_CONTAINER_ID);
        verifierRef.current = verifier;
        // Render the reCAPTCHA widget - this is required before using it
        verifier
            .render()
            .then(() => {
            setVerifierReady(true);
        })
            .catch((err) => {
            // Ignore "already rendered" errors - this can happen during re-initialization
            // and is not a problem since the existing widget is still usable
            const errorMessage = err?.message || '';
            if (errorMessage.includes('already been rendered')) {
                setVerifierReady(true);
                return;
            }
            setError('Failed to initialize security verification. Please refresh the page.');
        });
    }, [mfaSmsService]);
    // Get phone hint for display
    const phoneFactor = mfaEnrolledFactors.find((f) => f.factorId === 'phone');
    const maskedPhone = formatMaskedPhone(phoneFactor?.phoneNumber);
    // Initialize verifier on mount
    useEffect(() => {
        // Prevent double initialization on mount
        if (verifierInitAttempted.current)
            return;
        verifierInitAttempted.current = true;
        // In Cypress, initialize immediately (no DOM needed for mock verifier)
        // Otherwise, small delay to ensure DOM is ready for reCAPTCHA
        const delay = isCypress.current ? 0 : 100;
        const timer = setTimeout(() => {
            initializeVerifier();
        }, delay);
        return () => clearTimeout(timer);
    }, [initializeVerifier]);
    // Cleanup on unmount
    useEffect(() => {
        return () => {
            // Only RecaptchaVerifier has a clear() method
            if (verifierRef.current && 'clear' in verifierRef.current) {
                try {
                    verifierRef.current.clear();
                }
                catch {
                    // Ignore cleanup errors
                }
            }
            verifierRef.current = null;
            verifierInitAttempted.current = false;
        };
    }, []);
    // Send SMS code
    const sendCode = useCallback(async () => {
        if (!mfaResolver || !verifierRef.current || !verifierReady) {
            setError('Unable to send verification code. Please try logging in again.');
            return;
        }
        // Find the index of the phone factor in resolver hints
        // (don't assume index 0 — user may have TOTP or other factors enrolled first)
        const phoneFactorIndex = mfaResolver.hints.findIndex((h) => h.factorId === 'phone');
        if (phoneFactorIndex === -1) {
            setError('No phone MFA factor found. Please contact support.');
            return;
        }
        setIsSendingCode(true);
        setError(null);
        try {
            const verificationId = await authService.sendMfaSmsCode(mfaResolver, verifierRef.current, phoneFactorIndex);
            setMfaChallenge((prev) => ({ ...prev, phoneVerificationId: verificationId }));
            setCodeSent(true);
            startCooldown();
            // Reinitialize verifier for potential resend
            // (RecaptchaVerifier can only be used once per verification)
            initializeVerifier();
        }
        catch (err) {
            const authError = err;
            console.error('SMS send error:', {
                code: authError.code,
                message: authError.message,
            });
            setError(getMfaErrorMessage(authError.code));
            // Reinitialize verifier after failure so user can retry
            initializeVerifier();
        }
        finally {
            setIsSendingCode(false);
        }
    }, [
        mfaResolver,
        verifierReady,
        authService,
        setMfaChallenge,
        initializeVerifier,
        startCooldown,
    ]);
    // NOTE: We intentionally do NOT auto-send on mount.
    // Invisible reCAPTCHA requires user interaction (button click) to work properly.
    // Auto-sending causes "NO_RECAPTCHA" / "INVALID_APP_CREDENTIAL" errors.
    // Verify the entered code
    // Accepts optional code parameter to handle auto-submit from PinInput's onComplete,
    // since React state updates are async and verificationCode state may be stale
    const verifyCode = async (code) => {
        const codeToVerify = code ?? verificationCode;
        if (!mfaResolver || !mfaPhoneVerificationId) {
            setError('Verification session expired. Please try again.');
            return;
        }
        if (!codeToVerify.trim()) {
            setError('Please enter the verification code.');
            return;
        }
        setIsVerifying(true);
        setError(null);
        try {
            const { user, accessToken } = await authService.verifyMfaSmsCode(mfaResolver, mfaPhoneVerificationId, codeToVerify.trim());
            // Update auth state before calling onSuccess (prevents AuthGuard redirect)
            setUser(user);
            setAccessToken(accessToken);
            setIsAuthenticated(true);
            apiClient.setAuthToken(accessToken);
            // Clear MFA state and call success callback
            clearMfaChallenge();
            onSuccess?.();
        }
        catch (err) {
            const authError = err;
            setError(getMfaErrorMessage(authError.code));
        }
        finally {
            setIsVerifying(false);
        }
    };
    // Handle resend
    const handleResend = () => {
        if (cooldownSeconds > 0)
            return;
        setVerificationCode('');
        sendCode();
    };
    // Handle cancel - clear MFA state and call cancel callback
    const handleCancel = () => {
        clearMfaState();
        onCancel?.();
    };
    const isVerifyDisabled = isVerifying || !verificationCode.trim();
    // Determine content based on state
    const renderContent = () => {
        // Check for session expiration FIRST, regardless of codeSent state
        // This handles cases where session expires after code was sent (timeout, network issues, etc.)
        if ((!mfaPending || !mfaResolver) && !isProcessing) {
            // Session expired - show error state with navigation option
            return (React__default.createElement(Stack, { itemsSpacing: '24' },
                React__default.createElement("div", { className: 'auth-page-header' },
                    React__default.createElement("h1", { className: 'auth-page-title' }, "Session expired"),
                    React__default.createElement("p", { className: 'auth-page-subtitle' }, "Your verification session has expired. Please log in again.")),
                React__default.createElement("div", { className: 'auth-actions' },
                    React__default.createElement(Button, { size: 'large', variant: 'filled', className: 'auth-primary-button', onPress: () => onCancel?.() }, "Back to log in"))));
        }
        // If code was already sent (user was in code entry phase), show code entry form
        // This handles both normal code entry and post-MFA processing states
        if (codeSent) {
            // If processing (post-MFA token generation), show disabled form with loading
            if (isProcessing) {
                return (React__default.createElement("form", null,
                    React__default.createElement(Stack, { itemsSpacing: '24' },
                        React__default.createElement("div", { className: 'auth-page-header' },
                            React__default.createElement("h1", { className: 'auth-page-title' }, "Enter your verification code"),
                            React__default.createElement("p", { className: 'auth-page-subtitle' }, "Check your phone and enter the 6-digit code we just sent via SMS")),
                        React__default.createElement("div", { className: 'auth-form-fields' },
                            React__default.createElement(PinInput, { length: 6, value: verificationCode, onChange: setVerificationCode, isDisabled: true, onComplete: () => { } })),
                        React__default.createElement("div", { className: 'auth-actions' },
                            React__default.createElement(Button, { type: 'submit', size: 'large', variant: 'filled', className: 'auth-primary-button', isDisabled: true, isLoading: true }, "Continue")))));
            }
            // Normal code entry form (fall through to existing code entry logic below)
        }
        // Initial state-user needs to click to send code (required for reCAPTCHA)
        if (!codeSent && !isSendingCode && !error) {
            return (React__default.createElement(Stack, { itemsSpacing: '24' },
                React__default.createElement("div", { className: 'auth-page-header' },
                    React__default.createElement("h1", { className: 'auth-page-title' }, "Verify your identity"),
                    React__default.createElement("p", { className: 'auth-page-subtitle' },
                        "We'll send a verification code to ",
                        maskedPhone)),
                React__default.createElement("div", { className: 'auth-actions' },
                    React__default.createElement(Button, { size: 'large', variant: 'filled', className: 'auth-primary-button', onPress: () => sendCode(), isDisabled: !verifierReady }, verifierReady ? 'Send code' : 'Loading...'),
                    React__default.createElement("button", { type: 'button', className: 'mfa-challenge-back-link', onClick: handleCancel }, "Back to log in"))));
        }
        // Code sending state (loading)
        if (isSendingCode && !codeSent) {
            return (React__default.createElement(Stack, { itemsSpacing: '24' },
                React__default.createElement("div", { className: 'auth-page-header' },
                    React__default.createElement("h1", { className: 'auth-page-title' }, "Verify your identity"),
                    React__default.createElement("p", { className: 'auth-page-subtitle' },
                        "Sending a 6-digit code to ",
                        maskedPhone,
                        "...")),
                React__default.createElement("div", { className: 'auth-actions' },
                    React__default.createElement(Button, { size: 'large', variant: 'filled', className: 'auth-primary-button', isDisabled: true, isLoading: true }, "Sending..."))));
        }
        // Error state when sending fails (before code sent)
        if (!codeSent && error) {
            return (React__default.createElement(Stack, { itemsSpacing: '24' },
                React__default.createElement("div", { className: 'auth-page-header' },
                    React__default.createElement("h1", { className: 'auth-page-title' }, "Verify your identity"),
                    React__default.createElement("p", { className: 'auth-page-subtitle' }, "We couldn't send the verification code.")),
                React__default.createElement("div", { className: 'auth-form-fields' },
                    React__default.createElement(Callout, { variant: 'error', message: error })),
                React__default.createElement("div", { className: 'auth-actions' },
                    React__default.createElement(Button, { size: 'large', variant: 'filled', className: 'auth-primary-button', onPress: () => sendCode(), isLoading: isSendingCode }, "Try again"),
                    React__default.createElement("button", { type: 'button', className: 'mfa-challenge-back-link', onClick: handleCancel }, "Back to log in"))));
        }
        // Code entry form (after code sent successfully)
        return (React__default.createElement("form", null,
            React__default.createElement(Stack, { itemsSpacing: '24' },
                React__default.createElement("div", { className: 'auth-page-header' },
                    React__default.createElement("h1", { className: 'auth-page-title' }, "Enter your verification code"),
                    React__default.createElement("p", { className: 'auth-page-subtitle' }, "Check your phone and enter the 6-digit code we just sent via SMS")),
                React__default.createElement("div", { className: 'auth-form-fields' },
                    React__default.createElement(PinInput, { length: 6, value: verificationCode, onChange: setVerificationCode, isDisabled: isVerifying || isSendingCode || isProcessing, onComplete: (code) => verifyCode(code) }),
                    error && React__default.createElement(Callout, { variant: 'error', message: error })),
                React__default.createElement("div", { className: 'auth-actions' },
                    React__default.createElement(Button, { type: 'submit', size: 'large', variant: 'filled', className: 'auth-primary-button', isDisabled: isVerifyDisabled || isProcessing, isLoading: isVerifying || isProcessing, onPress: () => verifyCode() }, "Continue"),
                    React__default.createElement("div", { className: 'mfa-resend-row' },
                        React__default.createElement("span", { className: 'mfa-resend-text' }, "Didn't receive a code?"),
                        cooldownSeconds > 0 ? (React__default.createElement("span", { className: 'mfa-resend-cooldown' },
                            "Resend in ",
                            cooldownSeconds,
                            "s")) : (React__default.createElement("button", { type: 'button', className: 'mfa-resend-link', onClick: handleResend, disabled: isSendingCode }, isSendingCode ? 'Sending...' : 'Resend'))),
                    React__default.createElement("button", { type: 'button', className: 'mfa-challenge-back-link', onClick: handleCancel }, "Back to log in")))));
    };
    // Single return with reCAPTCHA container always present
    return (React__default.createElement("div", { className: 'mfa-challenge-content' },
        React__default.createElement("div", { id: RECAPTCHA_CONTAINER_ID }),
        renderContent()));
}

export { MfaChallengeForm };
//# sourceMappingURL=MfaChallengeForm.js.map
